import React, { useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { useLanguage } from '../context/LanguageContext';

const BirthCertificate = () => {
  const { language } = useLanguage();
  
  const [formData, setFormData] = useState({
    // Applicant
    applicantName: '',
    mobileNumber: '',
    
    // Certificate Details (matching the image fields)
    childNameMarathi: '',          // बाळाचे पूर्ण नाव
    fatherNameMarathi: '',         // वडिलांचे पूर्ण नाव
    motherNameMarathi: '',         // आईचे पूर्ण नाव
    birthDate: '',                 // जन्म दिनांक
    gender: '',                    // लिंग
    placeOfBirth: language === 'marathi' ? 'घर' : 'House', // जन्म ठिकाण
    registrationNumber: 'REG' + Date.now().toString().slice(-6), // Auto-generated registration number
    registrationDate: new Date().toISOString().split('T')[0], // Current date
    permanentAddress: '', // आई-वडिलांचा पत्ता
    
    // Payment
    amount: '20',                  // Nominal fee for duplicate/search
    paymentMethod: '',
    upiId: 'sangramshinde7007@okhdfcbank',
  });

  const [showPayment, setShowPayment] = useState(false);
  const [isPaymentProcessing, setIsPaymentProcessing] = useState(false);
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const [receiptData, setReceiptData] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.applicantName || !formData.mobileNumber || !formData.childNameMarathi ||
        !formData.fatherNameMarathi || !formData.motherNameMarathi || !formData.birthDate ||
        !formData.gender || !formData.registrationNumber) {
      alert(language === 'marathi' ? 'कृपया सर्व अनिवार्य माहिती भरा' : 'Please fill all mandatory information');
      return;
    }

    if (formData.mobileNumber.length !== 10 || !/^\d{10}$/.test(formData.mobileNumber)) {
      alert(language === 'marathi' ? 'मोबाईल नंबर १० अंकी असावा' : 'Mobile number must be 10 digits');
      return;
    }

    // Basic date validation
    if (new Date(formData.birthDate) > new Date()) {
      alert(language === 'marathi' ? 'जन्म दिनांक आजच्या तारखेपेक्षा जुना असावा' : 'Birth date should be older than today\'s date');
      return;
    }

    setShowPayment(true);
  };

  const upiQRValue = formData.upiId && formData.amount
    ? `upi://pay?pa=${formData.upiId}&pn=Inam%20Dhamani%20Grampanchayat&am=${formData.amount}&cu=INR&tn=Birth%20Certificate%20Fee`
    : '';

  const handlePayment = (e) => {
    e.preventDefault();
    setIsPaymentProcessing(true);

    setTimeout(() => {
      setIsPaymentProcessing(false);

      const receipt = {
        ...formData,
        transactionId: 'BC' + Date.now().toString().slice(-8),
        paymentDate: new Date().toLocaleDateString(language === 'marathi' ? 'mr-IN' : 'en-IN'),
        paymentTime: new Date().toLocaleTimeString(language === 'marathi' ? 'mr-IN' : 'en-IN'),
        grampanchayat: language === 'marathi' ? 'इनाम धामणी ग्रामपंचायत' : 'Inam Dhamani Gram Panchayat',
      };

      setReceiptData(receipt);
      setPaymentSuccess(true);

      alert(language === 'marathi' ? 'पेमेंट यशस्वी! पुष्टीकरण संदेश मोबाईलवर येईल.' : 'Payment successful! Confirmation message will be sent to mobile.');
    }, 2000);
  };

  const handleDownloadReceipt = () => {
    if (!receiptData) return;

    const content = language === 'marathi' ? `
जन्म दाखला अर्ज / डुप्लिकेट रसीद
${receiptData.grampanchayat}

रसीद क्र.: ${receiptData.transactionId}
दिनांक: ${receiptData.paymentDate}   वेळ: ${receiptData.paymentTime}

अर्जदार: ${receiptData.applicantName}
मोबाईल: ${receiptData.mobileNumber}

बाळाचे नाव: ${receiptData.childNameMarathi}
वडील: ${receiptData.fatherNameMarathi}
आई: ${receiptData.motherNameMarathi}
जन्म दिनांक: ${receiptData.birthDate}
लिंग: ${receiptData.gender === 'male' ? 'पुरुष' : receiptData.gender === 'female' ? 'स्त्री' : 'इतर'}
जन्म ठिकाण: ${receiptData.placeOfBirth}
नोंदणी क्र.: ${receiptData.registrationNumber}
नोंदणी दिनांक: ${receiptData.registrationDate}

फी: ₹${receiptData.amount}   पद्धत: ${receiptData.paymentMethod.toUpperCase()}

कंप्युटरद्वारे निर्मित रसीद - कृपया सुरक्षित ठेवा
    ` : `
Birth Certificate Application / Duplicate Receipt
${receiptData.grampanchayat}

Receipt No.: ${receiptData.transactionId}
Date: ${receiptData.paymentDate}   Time: ${receiptData.paymentTime}

Applicant: ${receiptData.applicantName}
Mobile: ${receiptData.mobileNumber}

Child's Name: ${receiptData.childNameMarathi}
Father: ${receiptData.fatherNameMarathi}
Mother: ${receiptData.motherNameMarathi}
Birth Date: ${receiptData.birthDate}
Gender: ${receiptData.gender === 'male' ? 'Male' : receiptData.gender === 'female' ? 'Female' : 'Other'}
Place of Birth: ${receiptData.placeOfBirth}
Registration No.: ${receiptData.registrationNumber}
Registration Date: ${receiptData.registrationDate}

Fee: ₹${receiptData.amount}   Method: ${receiptData.paymentMethod.toUpperCase()}

Computer generated receipt - please keep safe
    `;

    const blob = new Blob([content], { type: 'text/plain;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `Birth_Certificate_Receipt_${receiptData.transactionId}.txt`;
    a.click();
    URL.revokeObjectURL(url);
  };

  const handleNewApplication = () => {
    setPaymentSuccess(false);
    setShowPayment(false);
    setReceiptData(null);
    setFormData({
      applicantName: '',
      mobileNumber: '',
      childNameMarathi: '',
      fatherNameMarathi: '',
      motherNameMarathi: '',
      birthDate: '',
      gender: '',
      placeOfBirth: language === 'marathi' ? 'घर' : 'House',
      registrationNumber: 'REG' + Date.now().toString().slice(-6),
      registrationDate: new Date().toISOString().split('T')[0],
      permanentAddress: '',
      amount: '20',
      paymentMethod: '',
      upiId: 'sangramshinde7007@okhdfcbank',
    });
  };

  // ─── Styles ───
  const formSectionStyle = {
    background: 'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)',
    borderRadius: '10px',
    padding: '20px',
    marginBottom: '20px',
    border: '1px solid #90caf9',
    boxShadow: '0 2px 10px rgba(33,150,243,0.1)',
  };

  const inputStyle = {
    background: '#ffffff',
    border: '1px solid #64b5f6',
    borderRadius: '6px',
    padding: '10px 15px',
    fontSize: '14px',
    width: '100%',
  };

  const labelStyle = {
    color: '#1565c0',
    fontSize: '14px',
    fontWeight: '600',
    marginBottom: '6px',
    display: 'block',
  };

  const sectionTitleStyle = {
    color: '#0d47a1',
    fontSize: '20px',
    fontWeight: '700',
    marginBottom: '18px',
    paddingBottom: '10px',
    borderBottom: '2px solid #2196f3',
    textAlign: 'center',
  };

  const requiredStar = { color: '#f44336', marginLeft: '4px', fontWeight: 'bold' };

  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-cyan-50 py-8 px-4">
      <div className="max-w-2xl mx-auto">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gradient-to-r from-blue-500 to-cyan-500 mb-4">
            <span className="text-3xl text-white">👶</span>
          </div>
          <h1 className="text-3xl font-bold text-gray-800 mb-2">{language === 'marathi' ? 'जन्म दाखला मागणी / डुप्लिकेट अर्ज' : 'Birth Certificate Request / Duplicate Application'}</h1>
          <p className="text-gray-600">{language === 'marathi' ? 'इनाम धामणी ग्रामपंचायत - जन्म नोंदणी सेवा' : 'Inam Dhamani Gram Panchayat - Birth Registration Service'}</p>
        </div>

        {!paymentSuccess ? (
          <form onSubmit={handleSubmit} className="space-y-8">
            {/* Applicant Section */}
            <div style={formSectionStyle}>
              <h2 style={sectionTitleStyle}>{language === 'marathi' ? 'अर्जदाराची माहिती' : 'Applicant Information'}</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label style={labelStyle}>{language === 'marathi' ? 'अर्जदाराचे पूर्ण नाव' : 'Applicant\'s Full Name'} <span style={requiredStar}>*</span></label>
                  <input type="text" name="applicantName" value={formData.applicantName} onChange={handleChange} required style={inputStyle} placeholder={language === 'marathi' ? 'संपूर्ण नाव' : 'Full Name'} />
                </div>
                <div>
                  <label style={labelStyle}>{language === 'marathi' ? 'मोबाईल नंबर' : 'Mobile Number'} <span style={requiredStar}>*</span></label>
                  <input type="tel" name="mobileNumber" value={formData.mobileNumber} onChange={handleChange} required pattern="\d{10}" maxLength={10} style={inputStyle} placeholder={language === 'marathi' ? '९XXXXXXXXX' : '9XXXXXXXXX'} />
                </div>
              </div>
            </div>

            {/* Certificate Details Section */}
            <div style={formSectionStyle}>
              <h2 style={sectionTitleStyle}>{language === 'marathi' ? 'जन्म प्रमाणपत्र तपशील (दाखल्यावर असलेली माहिती)' : 'Birth Certificate Details (Information on certificate)'}</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label style={labelStyle}>{language === 'marathi' ? 'बाळाचे पूर्ण नाव' : 'Child\'s Full Name'} <span style={requiredStar}>*</span></label>
                  <input type="text" name="childNameMarathi" value={formData.childNameMarathi} onChange={handleChange} required style={inputStyle} placeholder={language === 'marathi' ? 'उदा. सुवर्णा' : 'e.g. Suvarna'} />
                </div>
                <div>
                  <label style={labelStyle}>{language === 'marathi' ? 'वडिलांचे पूर्ण नाव' : 'Father\'s Full Name'} <span style={requiredStar}>*</span></label>
                  <input type="text" name="fatherNameMarathi" value={formData.fatherNameMarathi} onChange={handleChange} required style={inputStyle} placeholder={language === 'marathi' ? 'वडिलांचे पूर्ण नाव' : 'Father\'s Full Name'} />
                </div>
                <div>
                  <label style={labelStyle}>{language === 'marathi' ? 'आईचे पूर्ण नाव' : 'Mother\'s Full Name'} <span style={requiredStar}>*</span></label>
                  <input type="text" name="motherNameMarathi" value={formData.motherNameMarathi} onChange={handleChange} required style={inputStyle} placeholder={language === 'marathi' ? 'उदा. येसा' : 'e.g. Yesa'} />
                </div>
                <div>
                  <label style={labelStyle}>{language === 'marathi' ? 'जन्म दिनांक' : 'Birth Date'} <span style={requiredStar}>*</span></label>
                  <input type="date" name="birthDate" value={formData.birthDate} onChange={handleChange} required style={inputStyle} />
                </div>
                <div>
                  <label style={labelStyle}>{language === 'marathi' ? 'लिंग' : 'Gender'} <span style={requiredStar}>*</span></label>
                  <select name="gender" value={formData.gender} onChange={handleChange} required style={inputStyle}>
                    <option value="">{language === 'marathi' ? 'निवडा' : 'Select'}</option>
                    <option value="male">{language === 'marathi' ? 'पुरुष' : 'Male'}</option>
                    <option value="female">{language === 'marathi' ? 'स्त्री' : 'Female'}</option>
                    <option value="other">{language === 'marathi' ? 'इतर' : 'Other'}</option>
                  </select>
                </div>
                <div>
                  <label style={labelStyle}>{language === 'marathi' ? 'जन्म ठिकाण' : 'Place of Birth'}</label>
                  <input type="text" name="placeOfBirth" value={formData.placeOfBirth} onChange={handleChange} style={inputStyle} placeholder={language === 'marathi' ? 'उदा. घर / हॉस्पिटल' : 'e.g. Home / Hospital'} />
                </div>
                <div>
                  <label style={labelStyle}>{language === 'marathi' ? 'नोंदणी क्रमांक' : 'Registration Number'} <span style={requiredStar}>*</span></label>
                  <input type="text" name="registrationNumber" value={formData.registrationNumber} onChange={handleChange} required style={inputStyle} placeholder={language === 'marathi' ? 'उदा. REG123456' : 'e.g. REG123456'} readOnly className="bg-gray-100" />
                </div>
                <div>
                  <label style={labelStyle}>{language === 'marathi' ? 'नोंदणी दिनांक' : 'Registration Date'} <span style={requiredStar}>*</span></label>
                  <input type="date" name="registrationDate" value={formData.registrationDate} onChange={handleChange} required style={inputStyle} readOnly className="bg-gray-100" />
                </div>
                <div className="md:col-span-2">
                  <label style={labelStyle}>{language === 'marathi' ? 'आई-वडिलांचा कायमचा पत्ता' : 'Parents\' Permanent Address'}</label>
                  <input type="text" name="permanentAddress" value={formData.permanentAddress} onChange={handleChange} style={inputStyle} placeholder={language === 'marathi' ? 'आई-वडिलांचा कायमचा पत्ता' : 'Parents\' Permanent Address'} />
                </div>
              </div>
            </div>

            {!showPayment && (
              <div className="flex justify-center gap-6 mt-8">
                <button type="submit" style={{ background: 'linear-gradient(135deg, #2196f3, #1976d2)', color: 'white', padding: '14px 40px', borderRadius: '8px', fontWeight: '600', border: 'none', cursor: 'pointer' }}>
                  {language === 'marathi' ? 'पुढे जा → पेमेंट' : 'Proceed → Payment'}
                </button>
                <button type="button" onClick={handleNewApplication} style={{ background: '#757575', color: 'white', padding: '14px 40px', borderRadius: '8px', fontWeight: '600', border: 'none', cursor: 'pointer' }}>
                  {language === 'marathi' ? 'रीसेट करा' : 'Reset'}
                </button>
              </div>
            )}
          </form>
        ) : null}

        {/* Payment Section */}
        {showPayment && !paymentSuccess && (
          <form onSubmit={handlePayment}>
            <div style={formSectionStyle}>
              <h2 style={sectionTitleStyle}>{language === 'marathi' ? 'पेमेंट' : 'Payment'} (₹ {formData.amount})</h2>

              <div className="p-5 bg-blue-50 rounded-lg mb-6">
                <div className="flex justify-between items-center">
                  <div>
                    <h3 className="font-bold text-blue-800">{language === 'marathi' ? 'एकूण रक्कम:' : 'Total Amount:'}</h3>
                    <p className="text-3xl font-bold text-green-700">₹{formData.amount}</p>
                  </div>
                  <div className="text-right">
                    <p className="text-sm text-gray-600">{language === 'marathi' ? 'अर्जदार' : 'Applicant'}</p>
                    <p className="font-semibold">{formData.applicantName}</p>
                  </div>
                </div>
              </div>

              <div>
                <h3 className="font-bold mb-4">{language === 'marathi' ? 'पेमेंट पद्धत' : 'Payment Method'}</h3>
                <div
                  onClick={() => setFormData({ ...formData, paymentMethod: 'upi' })}
                  style={{
                    padding: '16px',
                    border: `2px solid ${formData.paymentMethod === 'upi' ? '#2196f3' : '#ccc'}`,
                    borderRadius: '10px',
                    background: formData.paymentMethod === 'upi' ? '#e3f2fd' : 'white',
                    cursor: 'pointer',
                  }}
                >
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center text-2xl">📱</div>
                    <div>
                      <h4 className="font-bold">UPI (Google Pay, PhonePe, Paytm)</h4>
                      <p className="text-sm text-gray-600">{language === 'marathi' ? 'QR स्कॅन करून पेमेंट करा' : 'Scan QR and pay'}</p>
                    </div>
                  </div>

                  {formData.paymentMethod === 'upi' && (
                    <div className="mt-6 space-y-6">
                      <div>
                        <label style={labelStyle}>{language === 'marathi' ? 'तुमचे UPI ID' : 'Your UPI ID'} <span style={requiredStar}>*</span></label>
                        <input type="text" name="upiId" value={formData.upiId} onChange={handleChange} required style={inputStyle} placeholder={language === 'marathi' ? 'उदा. sangramshinde7007@okhdfcbank' : 'e.g. sangramshinde7007@okhdfcbank'} />
                      </div>

                      {upiQRValue && (
                        <div className="flex flex-col items-center p-6 bg-white rounded-xl border shadow-md">
                          <p className="font-semibold mb-4 text-lg">{language === 'marathi' ? 'QR स्कॅन करून पेमेंट करा' : 'Scan QR and pay'}</p>
                          <QRCodeSVG value={upiQRValue} size={240} level="H" fgColor="#000" bgColor="#fff" marginSize={4} />
                          <p className="mt-4 font-medium">{language === 'marathi' ? 'रक्कम:' : 'Amount:'} ₹{formData.amount}</p>
                          <p className="text-sm text-gray-600 mt-1">{formData.upiId}</p>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>

              <div className="flex justify-between mt-10">
                <button type="button" onClick={() => setShowPayment(false)} style={{ background: '#9e9e9e', color: 'white', padding: '12px 32px', borderRadius: '8px', fontWeight: '600', border: 'none' }}>
                  {language === 'marathi' ? 'मागे जा' : 'Go Back'}
                </button>
                <button type="submit" disabled={!formData.paymentMethod || isPaymentProcessing} style={{
                  background: (!formData.paymentMethod || isPaymentProcessing) ? '#bdbdbd' : 'linear-gradient(135deg, #4caf50, #2e7d32)',
                  color: 'white',
                  padding: '12px 40px',
                  borderRadius: '8px',
                  fontWeight: '600',
                  border: 'none',
                  cursor: formData.paymentMethod && !isPaymentProcessing ? 'pointer' : 'not-allowed',
                  opacity: formData.paymentMethod && !isPaymentProcessing ? 1 : 0.6,
                }}>
                  {isPaymentProcessing ? (language === 'marathi' ? 'प्रक्रिया सुरू आहे...' : 'Processing...') : (language === 'marathi' ? 'पेमेंट पूर्ण करा' : 'Complete Payment')}
                </button>
              </div>
            </div>
          </form>
        )}

        {/* Success & Receipt */}
        {paymentSuccess && receiptData && (
          <div style={{ ...formSectionStyle, background: 'linear-gradient(135deg, #e8f5e9, #c8e6c9)' }}>
            <div className="text-center mb-8">
              <div className="inline-flex w-24 h-24 rounded-full bg-green-500 items-center justify-center mb-4">
                <span className="text-5xl">✅</span>
              </div>
              <h2 className="text-3xl font-bold text-green-800">{language === 'marathi' ? 'पेमेंट यशस्वी!' : 'Payment Successful!'}</h2>
              <p className="text-gray-700 mt-2">{language === 'marathi' ? 'तुमचा जन्म दाखला अर्ज यशस्वीपणे नोंदवला गेला' : 'Your birth certificate application has been registered successfully'}</p>
            </div>

            <div className="bg-white p-6 rounded-lg border border-green-300 shadow-md">
              <h3 className="text-xl font-bold text-center mb-6 text-green-800">{language === 'marathi' ? 'जन्म दाखला अर्ज रसीद' : 'Birth Certificate Application Receipt'}</h3>

              <div className="space-y-4 text-sm">
                <div className="grid grid-cols-2 gap-4 pb-4 border-b">
                  <div><strong>{language === 'marathi' ? 'रसीद क्र.:' : 'Receipt No.:'}</strong> {receiptData.transactionId}</div>
                  <div><strong>{language === 'marathi' ? 'दिनांक:' : 'Date:'}</strong> {receiptData.paymentDate}</div>
                </div>

                <div>
                  <strong className="block mb-2">{language === 'marathi' ? 'बाळाची माहिती:' : 'Child\'s Information:'}</strong>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                    <div>{language === 'marathi' ? 'नाव:' : 'Name:'} <strong>{receiptData.childNameMarathi}</strong></div>
                    <div>{language === 'marathi' ? 'वडील:' : 'Father:'} <strong>{receiptData.fatherNameMarathi}</strong></div>
                    <div>{language === 'marathi' ? 'आई:' : 'Mother:'} <strong>{receiptData.motherNameMarathi}</strong></div>
                    <div>{language === 'marathi' ? 'जन्म दिनांक:' : 'Birth Date:'} <strong>{receiptData.birthDate}</strong></div>
                    <div>{language === 'marathi' ? 'नोंदणी क्र.:' : 'Registration No.:'} <strong>{receiptData.registrationNumber}</strong></div>
                  </div>
                </div>

                <div className="pt-4 border-t">
                  <strong className="block mb-2">{language === 'marathi' ? 'पेमेंट:' : 'Payment:'}</strong>
                  <div className="flex justify-between">
                    <span>{language === 'marathi' ? 'रक्कम:' : 'Amount:'}</span>
                    <span className="font-bold text-green-700">₹{receiptData.amount}</span>
                  </div>
                  <div className="flex justify-between">
                    <span>{language === 'marathi' ? 'पद्धत:' : 'Method:'}</span>
                    <span className="font-bold">{receiptData.paymentMethod.toUpperCase()}</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex justify-center gap-6 mt-10">
              <button onClick={handleDownloadReceipt} style={{ background: 'linear-gradient(135deg, #2196f3, #1976d2)', color: 'white', padding: '14px 32px', borderRadius: '8px', fontWeight: '600', border: 'none' }}>
                {language === 'marathi' ? '📄 रसीद डाउनलोड करा' : '📄 Download Receipt'}
              </button>
              <button onClick={handleNewApplication} style={{ background: 'linear-gradient(135deg, #4caf50, #2e7d32)', color: 'white', padding: '14px 32px', borderRadius: '8px', fontWeight: '600', border: 'none' }}>
                {language === 'marathi' ? 'नवीन अर्ज' : 'New Application'}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default BirthCertificate;